"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantMockDataType = exports.CreateSchema = exports.UpdateSchema = exports.SettingsSchema = exports.ServerSetupSchema = exports.AKSSettingsSchema = exports.PriceListSchema = exports.TenantStatusSchema = exports.PaymentInterval = exports.billingPriceList = exports.SKU = exports.organizeInvoiceLines = exports.InvoiceType = exports.getBillableLicense = exports.ErpVendorType = exports.TenantStatus = exports.ReferenceIdType = exports.TenantType = void 0;
const Joi = __importStar(require("joi"));
const moment_1 = __importDefault(require("moment"));
const __1 = require("..");
const customer_care_1 = require("../customer-care");
const customers_1 = require("../customers");
const payment_plans_1 = require("../economy/payment-plans");
const performed_by_1 = require("../performed-by");
var TenantType;
(function (TenantType) {
    TenantType["AccountsReceivable"] = "ACCOUNTS_RECEIVABLE";
    TenantType["Agency"] = "AGENCY";
})(TenantType || (exports.TenantType = TenantType = {}));
var ReferenceIdType;
(function (ReferenceIdType) {
    ReferenceIdType["CustomerReferenceId"] = "CUSTOMER_REFERENCE_ID";
    ReferenceIdType["CaseVoucherReferenceId"] = "CASE_VOUCHER_REFERENCE_ID";
})(ReferenceIdType || (exports.ReferenceIdType = ReferenceIdType = {}));
var TenantStatus;
(function (TenantStatus) {
    TenantStatus["GettingStarted"] = "GETTING_STARTED";
    TenantStatus["Demo"] = "DEMO";
    TenantStatus["Active"] = "ACTIVE";
    TenantStatus["Sandbox"] = "SANDBOX";
    TenantStatus["Disabled"] = "DISABLED";
})(TenantStatus || (exports.TenantStatus = TenantStatus = {}));
var ErpVendorType;
(function (ErpVendorType) {
    ErpVendorType["EConomic"] = "E_CONOMIC";
})(ErpVendorType || (exports.ErpVendorType = ErpVendorType = {}));
const isInInterval = (from, date, to) => (0, moment_1.default)(date).isAfter(from) && (0, moment_1.default)(date).isBefore(to);
const getBillableLicense = (tenant, date) => {
    if (!tenant.paymentTerms.paymentInterval)
        return null;
    let from;
    let to;
    let quantity;
    switch (tenant.paymentTerms.paymentInterval) {
        case PaymentInterval.Monthly:
            from = (0, moment_1.default)(date).startOf('month');
            to = (0, moment_1.default)(date).endOf('month');
            quantity = 1;
            break;
        case PaymentInterval.Quarterly:
            from = (0, moment_1.default)(date).startOf('quarter');
            to = (0, moment_1.default)(date).endOf('quarter');
            quantity = 3;
            if (!isInInterval(from, date, from.clone().add(1, 'month'))) {
                return null;
            }
            break;
        case PaymentInterval.QuarterlyMonthAdvance:
            from = (0, moment_1.default)(date).add(1, 'month').startOf('quarter');
            to = (0, moment_1.default)(date).add(1, 'month').endOf('quarter');
            quantity = 3;
            if (!isInInterval(from.clone().subtract(1, 'month'), date, from)) {
                return null;
            }
            break;
        case PaymentInterval.Yearly:
            from = (0, moment_1.default)(date).startOf('year');
            to = (0, moment_1.default)(date).endOf('year');
            quantity = 12;
            if (!isInInterval(from, date, from.clone().add(1, 'month'))) {
                return null;
            }
            break;
        default:
            throw new Error(`Payment interval (${tenant.paymentTerms.paymentInterval}) not supported`);
    }
    return {
        date: date.format(),
        period: {
            from: from.format(),
            to: to.format(),
        },
        lines: [
            {
                amount: typeof tenant.billingPriceList[SKU.MonthlyBaseFee] === 'number'
                    ? tenant.billingPriceList[SKU.MonthlyBaseFee]
                    : exports.billingPriceList[SKU.MonthlyBaseFee],
                quantity,
                sku: SKU.MonthlyBaseFee,
                unit: 'Måneder',
            },
        ],
    };
};
exports.getBillableLicense = getBillableLicense;
var InvoiceType;
(function (InvoiceType) {
    InvoiceType["Consumption"] = "CONSUMPTION";
    InvoiceType["License"] = "LICENSE";
    InvoiceType["Consultancy"] = "CONSULTANCY";
})(InvoiceType || (exports.InvoiceType = InvoiceType = {}));
const organizeInvoiceLines = (invoiceLines) => Object.values(invoiceLines.reduce((acc, line) => {
    const crediting = line.amount < 0;
    const k = `${line.sku}${crediting ? '-crediting' : ''}${line.description || ''}`;
    if (!acc[k]) {
        acc[k] = {
            lines: [],
            amount: 0,
            quantity: 0,
            description: line.description,
            unit: line.unit,
            sku: line.sku,
            crediting,
        };
    }
    acc[k].lines = acc[k].lines.concat(line);
    acc[k].amount += line.amount;
    acc[k].quantity += line.quantity;
    return acc;
}, {}));
exports.organizeInvoiceLines = organizeInvoiceLines;
var SKU;
(function (SKU) {
    SKU["DomesticSMS"] = "DOMESTIC_SMS";
    SKU["InternationalSMS"] = "INTERNATIONAL_SMS";
    SKU["DomesticAutoCall"] = "DOMESTIC_AUTO_CALL";
    SKU["InternationalAutoCall"] = "INTERNATIONAL_AUTO_CALL";
    SKU["DomesticLetter"] = "DOMESTIC_LETTER";
    SKU["InternationalLetter"] = "INTERNATIONAL_LETTER";
    SKU["ReturnLetter"] = "RETURN_LETTER";
    SKU["DigitalSignature"] = "DIGITAL_SIGNATURE";
    SKU["PhoneLookup"] = "PHONE_LOOKUP";
    SKU["EmailLookup"] = "EMAIL_LOOKUP";
    SKU["CaseCreation"] = "CASE_CREATION";
    SKU["MigratedCaseCreation"] = "MIGRATED_CASE_CREATION";
    SKU["MonthlyBaseFee"] = "MONTHLY_BASE_FEE";
    SKU["FreezingSystemSignOn"] = "FREEZING_SYSTEM_SIGN_ON";
    SKU["FreezingSystemSignOff"] = "FREEZING_SYSTEM_SIGN_OFF";
    SKU["EBoks"] = "EBOKS";
    SKU["MitID"] = "MITID";
    SKU["NemId"] = "NEMID";
    SKU["Consultancy"] = "CONSULTANCY";
})(SKU || (exports.SKU = SKU = {}));
const STANDARD_CASE_FEE = 2000;
exports.billingPriceList = {
    [SKU.DomesticAutoCall]: 200,
    [SKU.InternationalAutoCall]: 200,
    [SKU.DomesticSMS]: 34,
    [SKU.InternationalSMS]: 100,
    [SKU.ReturnLetter]: 385,
    [SKU.DomesticLetter]: 1849,
    [SKU.InternationalLetter]: 4060,
    [SKU.DigitalSignature]: 1328,
    [SKU.PhoneLookup]: 43,
    [SKU.EmailLookup]: 12,
    [SKU.CaseCreation]: STANDARD_CASE_FEE,
    [SKU.MigratedCaseCreation]: STANDARD_CASE_FEE,
    [SKU.MonthlyBaseFee]: 1900000,
    [SKU.FreezingSystemSignOn]: 58,
    [SKU.FreezingSystemSignOff]: 58,
    [SKU.EBoks]: 296,
    [SKU.MitID]: 85,
    [SKU.NemId]: 195,
    [SKU.Consultancy]: 125000,
};
var PaymentInterval;
(function (PaymentInterval) {
    PaymentInterval["Quarterly"] = "QUARTERLY";
    PaymentInterval["QuarterlyMonthAdvance"] = "QUARTERLY_MONTH_ADVANCE";
    PaymentInterval["Monthly"] = "MONTHLY";
    PaymentInterval["Yearly"] = "YEARLY";
})(PaymentInterval || (exports.PaymentInterval = PaymentInterval = {}));
exports.TenantStatusSchema = Joi.string().valid(...Object.values(TenantStatus));
exports.PriceListSchema = Joi.object({
    caseCloseFee: Joi.number().integer().allow(null),
    clientCaseCreationFee: Joi.number().integer().allow(null),
    tenantCaseCreationFee: Joi.number().integer().allow(null),
    RKIRegistrationFee: Joi.number().integer().allow(null),
    paymentDemandFee: Joi.number().integer().allow(null),
    fogedrekvisitionsFee: Joi.number().integer().allow(null),
    folkeregisteropslagsFee: Joi.number().integer().allow(null),
    anmeldelseAfKravFee: Joi.number().integer().allow(null),
    legalAdviceHourlyRate: Joi.number().integer().allow(null),
    afslysningAfUdlaeg: Joi.number().integer().allow(null),
});
exports.AKSSettingsSchema = Joi.object({
    key: Joi.string().allow(''),
    code: Joi.string().allow(''),
    password: Joi.string().allow(''),
    username: Joi.string().allow(''),
    limit: Joi.number().allow(0),
});
exports.ServerSetupSchema = Joi.object({
    type: Joi.string().valid('SFTP', 'FTP').required(),
    data: Joi.object({
        user: Joi.string().required(),
        host: Joi.string().required(),
        password: Joi.string().required(),
        port: Joi.number().required(),
    }),
});
exports.SettingsSchema = Joi.object({
    autoImposeCompensationCost: Joi.boolean().allow(null),
    autoSendInteractionsAfterXVerifications: Joi.number()
        .min(0)
        .max(9999)
        .allow(null),
    preventSendingLetters: Joi.boolean().allow(null),
    preventAttachingBillingsToBillingEmails: Joi.boolean().allow(null),
    disableWorkflows: Joi.boolean().allow(null),
    paymentPlanFoundationTemplateId: Joi.string().uuid().allow(null),
    selfCollection: Joi.boolean().allow(null),
    twoFactorRequired: Joi.boolean().allow(null),
    aiDisabled: Joi.boolean().allow(null),
    legisIntegration: Joi.boolean().allow(null),
    isPayoutTenant: Joi.boolean().allow(null),
    outboundCall: Joi.boolean().allow(null),
    autoDebtRegister: Joi.boolean().allow(null),
    vatConnectorId: Joi.string().uuid().allow(null),
    autoVerifyCases: Joi.boolean().allow(null),
    advokatindestaaelse: Joi.boolean().allow(null),
    autoRKIOpen: Joi.boolean().allow(null),
    autoRKIIgnoreUnresolvedOppositions: Joi.boolean().allow(null),
    autoRKIDeleteOnCaseEnd: Joi.boolean().allow(null),
    responsibleForUpdateTypes: Joi.any().allow(null),
    accountingExportSettings: Joi.any().allow(null),
    letterSetup: Joi.object({
        returnAddress: __1.AddressSchema,
        server: exports.ServerSetupSchema,
    }).allow(null),
    referenceIdFinders: Joi.array().items(Joi.object({
        referenceIdType: Joi.string()
            .valid(...Object.values(ReferenceIdType))
            .required(),
        referenceIdLength: Joi.number().required(),
        referenceIdMin: Joi.number().allow(null),
        referenceIdMax: Joi.number().allow(null),
    })),
    tribunal: Joi.object({
        courtRepresentative: Joi.string(),
        courtPhone: Joi.string(),
        courtEmail: Joi.string(),
        courtRegistrationNumber: Joi.string(),
        courtAccountNumber: Joi.string(),
    }),
    debtorweb: Joi.object({
        contactUsText: Joi.string(),
    }),
    billingTextFields: Joi.object({
        underCreditorName: Joi.string().allow(null),
        endWhenReceivingPayment: Joi.string().allow(null),
        endWhenSendingPayment: Joi.string().allow(null),
    }).allow(null),
    workflows: Joi.object({
        executionInterval: Joi.object({
            fromHour: Joi.number().integer().allow(null),
            fromMinute: Joi.number().integer().allow(null),
            toHour: Joi.number().integer().allow(null),
            toMinute: Joi.number().integer().allow(null),
        }),
    }),
});
const TenantBillingEmailsScheme = Joi.object({
    to: Joi.string().allow(null),
    cc: Joi.string().allow(null),
    bcc: Joi.string().allow(null),
});
exports.UpdateSchema = Joi.object({
    name: Joi.string(),
    countryCode: Joi.string(),
    currency: Joi.string(),
    collectorIdentityId: Joi.string().uuid(),
    defaultWorkflowId: Joi.string().uuid(),
    defaultBillingModelId: Joi.string().uuid().allow(null),
    defaultBillingAppendixSetupId: Joi.string().uuid().allow(null),
    status: exports.TenantStatusSchema,
    economicToken: Joi.string(),
    address: __1.AddressSchema.allow(null),
    priceList: exports.PriceListSchema,
    settings: exports.SettingsSchema,
    embeds: Joi.any(),
    defaultProcedures: Joi.any(),
    billingPriceList: Joi.any(),
    billingEnabled: Joi.boolean(),
    referenceId: Joi.string(),
    vatNumber: Joi.string(),
    paymentTerms: Joi.any(),
    invoicingEmails: TenantBillingEmailsScheme,
    caseMergeRules: customers_1.CaseMergeRulesSchema.allow(null),
    paymentPlansConfig: payment_plans_1.PaymentPlansConfigSchema.allow(null),
    customerCare: customer_care_1.CustomerCareSchema.allow(null),
    credits: Joi.any(),
    aksSettings: exports.AKSSettingsSchema.allow({}),
    caseGroupWorkflows: Joi.any().allow(null),
    bankAccountDetails: Joi.object({
        type: Joi.string()
            .valid(...Object.values(__1.BankAccountType))
            .required(),
        bankName: Joi.string().required(),
        registrationNumber: Joi.string().required(),
        accountNumber: Joi.string().required(),
        createdAt: Joi.string().required(),
    }).allow(null),
    erpVendor: Joi.object({
        type: Joi.string()
            .valid(...Object.values(ErpVendorType))
            .required(),
        token: Joi.string().required(),
    }).allow(null),
});
exports.CreateSchema = Joi.object({
    type: Joi.string()
        .valid(...Object.values(TenantType))
        .required(),
    id: Joi.string().uuid(),
    name: Joi.string().required(),
    address: __1.AddressSchema.allow(null),
    referenceId: Joi.string().allow(null),
    vatNumber: Joi.string().allow(null),
    countryCode: Joi.string().required(),
    currency: Joi.string().required(),
    lang: Joi.string().required(),
    timezone: Joi.string().required(),
    collectorIdentityId: Joi.string().uuid().required(),
    defaultWorkflowId: Joi.string().uuid(),
    defaultBillingModelId: Joi.string().uuid().allow(null),
    defaultBillingAppendixSetupId: Joi.string().uuid().allow(null),
    status: exports.TenantStatusSchema,
    economicToken: Joi.string(),
    createdBy: performed_by_1.PerformedBySchema.allow(null),
});
var TenantMockDataType;
(function (TenantMockDataType) {
    TenantMockDataType["PreCollection"] = "PRE_COLLECTION";
    TenantMockDataType["DebtCollection"] = "DEBT_COLLECTION";
})(TenantMockDataType || (exports.TenantMockDataType = TenantMockDataType = {}));
//# sourceMappingURL=index.js.map